import MenuItem from '@material-ui/core/MenuItem'
import { ComponentProps, forwardRef } from 'react'

import { useStyles } from './styles'

export const Item = forwardRef<HTMLLIElement, ComponentProps<typeof MenuItem>>(
  (props, ref) => {
    const classes = useStyles()

    return <MenuItem ref={ref} {...props} className={classes.menuitem} />
  },
)

Item.displayName = 'Item'
